// villa1
import v1_1 from './villa01/v1.1.jpeg';
import v1_2 from './villa01/v1.2.jpeg';
import v1_3 from './villa01/v1.3.jpeg';
import v1_4 from './villa01/v1.4.jpeg';
import v1_5 from './villa01/v1.5.jpeg';
import v1_6 from './villa01/v1.6.jpeg';
import v1_7 from './villa01/v1.7.jpeg';
import v1_8 from './villa01/v1.8.jpeg';
import v1_9 from './villa01/v1.9.jpeg';
import v1_10 from './villa01/v1.10.jpeg';
import v1_11 from './villa01/v1.11.jpeg';
import v1_12 from './villa01/v1.12.jpeg';
import v1_13 from './villa01/v1.13.jpeg';
import v1_14 from './villa01/v1.14.jpeg';

// villa2
import v2_1 from './villa02/v2.1.jpeg';
import v2_2 from './villa02/v2.2.jpeg';
import v2_3 from './villa02/v2.3.jpeg';
import v2_4 from './villa02/v2.4.jpeg';
import v2_5 from './villa02/v2.5.jpeg';
import v2_6 from './villa02/v2.6.jpeg';
import v2_7 from './villa02/v2.7.jpeg';
import v2_8 from './villa02/v2.8.jpeg';
import v2_9 from './villa02/v2.9.jpeg';
import v2_10 from './villa02/v2.10.jpeg';
import v2_11 from './villa02/v2.11.jpeg';
import v2_12 from './villa02/v2.12.jpeg';
import v2_13 from './villa02/v2.13.jpeg';
import v2_14 from './villa02/v2.14.jpeg';
import v2_15 from './villa02/v2.15.jpeg';
import v2_16 from './villa02/v2.16.jpeg';
import v2_17 from './villa02/v2.17.jpeg';
import v2_18 from './villa02/v2.18.jpeg';
import v2_19 from './villa02/v2.19.jpeg';

// villa4
import v4_1 from './villa04/v4.1.jpg';
// import v4_2 from './v4.2.jpeg';
// import v4_3 from './v4.3.jpeg';
// import v4_4 from './v4.4.jpeg';
// import v4_5 from './v4.5.jpeg';
// import v4_6 from './v4.6.jpg';
// import v4_7 from './v4.7.jpg';
// import v4_8 from './v4.8.jpg';
// import v4_9 from './v4.9.jpg';
// import v4_10 from './v4.10.jpg';
// import v4_11 from './v4.11.jpg';
// import v4_12 from './v4.12.jpg';
// import v4_13 from './v4.13.jpg';
// import v4_14 from './v4.14.jpg';
// import v4_15 from './v4.15.jpg';
// import v4_16 from './v4.16.jpg';

// villa5
import v5_1 from './villa05/v5.1.jpeg';
import v5_2 from './villa05/v5.2.jpeg';
import v5_3 from './villa05/v5.3.jpeg';
import v5_4 from './villa05/v5.4.jpeg';
import v5_5 from './villa05/v5.5.jpeg';
import v5_6 from './villa05/v5.6.jpeg';
import v5_7 from './villa05/v5.7.jpeg';
import v5_8 from './villa05/v5.8.jpeg';
import v5_9 from './villa05/v5.9.jpeg';
import v5_10 from './villa05/v5.10.jpeg';
import v5_11 from './villa05/v5.11.jpeg';
import v5_12 from './villa05/v5.12.jpeg';
import v5_13 from './villa05/v5.13.jpeg';
import v5_14 from './villa05/v5.14.jpeg';
import v5_15 from './villa05/v5.15.jpeg';
import v5_16 from './villa05/v5.16.jpeg';
import v5_18 from './villa05/v5.18.jpeg';
import v5_19 from './villa05/v5.19.jpeg';
import v5_20 from './villa05/v5.20.jpeg';
import v5_21 from './villa05/v5.21.jpeg';
import v5_22 from './villa05/v5.22.jpeg';
import v5_23 from './villa05/v5.23.jpeg';
import v5_24 from './villa05/v5.24.jpeg';
import v5_25 from './villa05/v5.25.jpeg';

// villa6
import v6_1 from './villa06/v6.1.jpeg';
import v6_2 from './villa06/v6.2.jpeg';
import v6_3 from './villa06/v6.3.jpeg';
import v6_4 from './villa06/v6.4.jpeg';
import v6_5 from './villa06/v6.5.jpeg';
import v6_7 from './villa06/v6.7.jpeg';
import v6_8 from './villa06/v6.8.jpeg';
import v6_9 from './villa06/v6.9.jpeg';
import v6_10 from './villa06/v6.10.jpeg';
import v6_11 from './villa06/v6.11.jpeg';
import v6_12 from './villa06/v6.12.jpeg';
import v6_13 from './villa06/v6.13.jpeg';
import v6_14 from './villa06/v6.14.jpeg';
import v6_15 from './villa06/v6.15.jpeg';
import v6_16 from './villa06/v6.16.jpeg';
import v6_17 from './villa06/v6.17.jpeg';
import v6_18 from './villa06/v6.18.jpeg';
import v6_19 from './villa06/v6.19.jpeg';
import v6_20 from './villa06/v6.20.jpeg';
import v6_21 from './villa06/v6.21.jpeg';

// villa7
import v7_1 from './villa07/v7.1.jpg';
import v7_2 from './villa07/v7.2.jpg';
import v7_3 from './villa07/v7.3.jpg';
import v7_4 from './villa07/v7.4.jpg';
import v7_5 from './villa07/v7.5.jpg';
import v7_6 from './villa07/v7.6.jpg';
import v7_7 from './villa07/v7.7.jpg';
import v7_8 from './villa07/v7.8.jpg';
import v7_9 from './villa07/v7.9.jpg';
import v7_10 from './villa07/v7.10.jpg';
import v7_11 from './villa07/v7.11.jpg';
import v7_12 from './villa07/v7.12.jpg';
import v7_13 from './villa07/v7.13.jpg';
import v7_14 from './villa07/v7.14.jpg';
import v7_15 from './villa07/v7.15.jpg';
import v7_16 from './villa07/v7.16.jpg';
import v7_18 from './villa07/v7.18.jpg';
import v7_19 from './villa07/v7.19.jpg';

// villa8
import v8_1 from './villa08/v8.1.jpg';
import v8_2 from './villa08/v8.2.jpg';
import v8_3 from './villa08/v8.3.jpg';
import v8_4 from './villa08/v8.4.jpg';
import v8_5 from './villa08/v8.5.jpg';
import v8_6 from './villa08/v8.6.jpg';
import v8_7 from './villa08/v8.7.jpg';
import v8_8 from './villa08/v8.8.jpg';
import v8_9 from './villa08/v8.9.jpg';
import v8_10 from './villa08/v8.10.jpg';
import v8_11 from './villa08/v8.11.jpg';
import v8_12 from './villa08/v8.12.jpg';
import v8_13 from './villa08/v8.13.jpg';
import v8_14 from './villa08/v8.14.jpg';
import v8_15 from './villa08/v8.15.jpg';
import v8_16 from './villa08/v8.16.jpg';


export const home_slider = {
  v1_1, v2_1, v4_1
};
export const villa1 = {
    v1_1, v1_2, v1_3, v1_4, v1_5, v1_6, v1_7, v1_8, v1_9, v1_10,
    v1_11, v1_12, v1_13, v1_14
  };

export const villa2 = {
    v2_1, v2_2, v2_3, v2_4, v2_5, v2_6, v2_7, v2_8, v2_9, v2_10, v2_11, v2_12, v2_13, v2_14, v2_15, v2_16, v2_17, v2_18, v2_19
  };


export const villa4 = {
  v4_1
};

export const villa5 = {
  v5_1, v5_2, v5_3, v5_4, v5_5, v5_6, v5_7, v5_8, v5_9, v5_10,
  v5_11, v5_12, v5_13, v5_14, v5_15, v5_16, v5_18, v5_19, v5_20,
  v5_21, v5_22, v5_23, v5_24, v5_25
};

export const villa6 = {
  v6_1, v6_2, v6_3, v6_4, v6_5, v6_7, v6_8, v6_9, v6_10,
  v6_11, v6_12, v6_13, v6_14, v6_15, v6_16, v6_17, v6_18, v6_19,
  v6_20, v6_21
};

export const villa7 = {
  v7_1, v7_2, v7_3, v7_4, v7_5, v7_6, v7_7, v7_8, v7_9, v7_10,
  v7_11, v7_12, v7_13, v7_14, v7_15, v7_16, v7_18, v7_19
};

export const villa8 = {
  v8_1, v8_2, v8_3, v8_4, v8_5, v8_6, v8_7, v8_8, v8_9, v8_10,
  v8_11, v8_12, v8_13, v8_14, v8_15, v8_16
};

export const interiorImg = {
  v1_3, v2_5, v1_12
}